exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-xs-12 {\n    margin:20px 0;\n}\n\n#dataOrario_0 {\n    width: 100%;\n\n}\n/*\n@media only screen and (max-width:991px) {\n    text-align: center;\n}\n*/\n@media only screen and (max-width:767px) {\n  .mat-dialog-content-ovh {\n      overflow: auto !important;\n  }\n}\n\n.btnAcquista,\n.btnAnnulla {\n  background-color: #ffffff;\n  border: 1px solid #5daada;\n  height: 50px;\n  width: 140px; \n  border-radius: 0;\n  margin-bottom: 10px;\n}\n\n.btnAcquista:hover,\n.btnAnnulla:hover {\n  background-color: #ffffff;\n  border: 1px solid #5daada;\n  border: 3px solid #f47920;\n  font-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-invia-messaggio-prenotazione/dialog-invia-messaggio-prenotazione.component.css
// module id = ../../../../../src/app/components/utilita/dialogs/dialog-invia-messaggio-prenotazione/dialog-invia-messaggio-prenotazione.component.css
// module chunks = main